import DashboardLayout from '@/layouts/DashboardLayout.vue';
import auth from '@/middleware/auth';
import type { Middleware } from '@/types/router';
import { BookmarksRouteName } from '@/types/router/name/bookmarks';
import { BookmarksRoutePath } from '@/types/router/path/bookmarks';

export default [
    {
        path: BookmarksRoutePath.Verses,
        name: BookmarksRouteName.Verses,
        component: () => import('@/pages/saved-contents/verses.vue'),
        meta: {
            group: 'bookmarks',
            sub: 'verses',
            title: 'Tersimpan',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: BookmarksRoutePath.Hadiths,
        name: BookmarksRouteName.Hadiths,
        component: () => import('@/pages/saved-contents/hadiths.vue'),
        meta: {
            group: 'bookmarks',
            sub: 'hadiths',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: BookmarksRoutePath.Duas,
        name: BookmarksRouteName.Duas,
        component: () => import('@/pages/saved-contents/duas.vue'),
        meta: {
            group: 'bookmarks',
            sub: 'duas',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    }
];
